<div class="chart-container" [style.height]="height + 'rem'">
    <canvas #canvas class="chart"></canvas>
    <div *ngIf="data$ | async as gauge">
        <h6 class="center-text" [style.font-size]="textSize + 'px'" [style.color]="gauge.color" [style.top]="'50%'">
            {{gauge.text}}
        </h6>
    </div>
</div>
